import { html } from '@design.estate/dees-element';
import { demoPage, demoSection, demoCode } from '../../../demos/templates.js';

export const demoFunc = () => demoPage('Hint', 'An inline note next to the thing it explains. Four types carry the catalog status colors; a plain sentence or slotted markup both work.', html`
  ${demoSection('Types', 'The type chooses the icon and the accent color. Info is the default.', html`
    <dees-hint text="Workspace names are visible to everyone you invite."></dees-hint>
    <dees-hint type="success" text="Your changes are saved and shared with your team."></dees-hint>
    <dees-hint type="warning" text="This workspace has no owner. Assign one before the trial ends."></dees-hint>
    <dees-hint type="error" text="The deployment could not reach the registry."></dees-hint>
    ${demoCode('<dees-hint type="warning" text="Assign an owner before the trial ends."></dees-hint>')}
  `)}
  ${demoSection('Slotted content', 'Use the default slot when the note needs markup. Text and slotted content render together.', html`
    <dees-hint type="info">Read the <a href="https://code.foss.global/design.estate/dees-catalog">component index</a> before adding a control.</dees-hint>
    <dees-hint type="warning" text="Rotation is due.">
      <strong> Keys older than 90 days stop working.</strong>
    </dees-hint>
    ${demoCode('<dees-hint type="info">Read the <a href="…">component index</a> first.</dees-hint>')}
  `)}
  ${demoSection('Empty hints', 'A hint with neither text nor slotted content reserves no space, so a conditional note needs no wrapper.', html`
    <p class="dees-demo-caption">There is an empty hint between these two lines.</p>
    <dees-hint></dees-hint>
    <p class="dees-demo-caption">It renders nothing until it is given text.</p>
  `)}
`);
